import React from "react";

const Footer = ({ commonData, clientData, menu }) => (
  <>
    <div className="footer p-4">
      <div className="copyright">
        {commonData.copyright}
        <div className="links-scroll">
          <div
            className="footer-links"
            dangerouslySetInnerHTML={{ __html: commonData.footerLinks }}
          ></div>
          <a className="scroll-top" href={`#${menu?.[0]?.menuSlug}`}>
            {commonData.scrollTop}
          </a>
        </div>
      </div>
    </div>

    <a
      href={
        clientData.clientLink !== "" ? clientData.clientLink : commonData.link
      }
      target="_blank"
      rel="noopener noreferrer"
      className="request-for-housing bggreen"
    >
      {commonData.requestText}
    </a>
  </>
);

export default Footer;
